import store from '@/store';
import { store as commonStore } from '~';
import 'vue-awesome/icons'; // import all icons

commonStore.sync(store);
store.dispatch('permissions/setLogin', ['loginLab', 'loginRabbit']);




// WEBPACK FOOTER //
// ./src/initCommon.js